var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_icon_",
    "data-name": "User icon ",
    transform: "translate(-7343 6007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17248",
    "data-name": "Rectangle 17248",
    width: 24,
    height: 24,
    transform: "translate(7343 -6007)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_employee-01-01",
    "data-name": "New employee-01-01",
    transform: "translate(7342.971 -6006.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38382",
    "data-name": "Path 38382",
    d: "M14.976,15.509a7.319,7.319,0,0,0,1.284-1.185,5.217,5.217,0,0,0,1.086-2.371c0-.2.1-.2.3-.3A2.084,2.084,0,0,0,18.73,8.2a.594.594,0,0,1-.1-.4c0-1.185.1-2.371,0-3.556A4.437,4.437,0,0,0,14.581.2a26.422,26.422,0,0,0-4.84.1,4.559,4.559,0,0,0-4.05,4.445V8a.544.544,0,0,1-.2.494,2.029,2.029,0,0,0,1.086,3.259c.3,0,.4.1.4.3A5.446,5.446,0,0,0,9.149,15.41l.1.1a2.922,2.922,0,0,0-.988.2A3.943,3.943,0,0,0,5.494,19.46v2.864c0,.3.1.4.4.4H18.236c.2,0,.4-.1.4-.3,0-1.086.1-2.272,0-3.358A3.839,3.839,0,0,0,14.976,15.509Z",
    fill: "#17171d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38383",
    "data-name": "Path 38383",
    d: "M6.4,4.068a.363.363,0,0,0-.1.3V7.92c.494-.4.988-.691,1.383-.988.691-.494,1.284-.988,1.975-1.482a.465.465,0,0,1,.593-.1c.889.4,1.778.889,2.568,1.284a5.742,5.742,0,0,0,3.852.593.947.947,0,0,1,.889.2c.1.1.2.1.3.2V4.167a.363.363,0,0,0-.1-.3A4.111,4.111,0,0,0,15.387,1.8a4.474,4.474,0,0,0-1.58-.3,27.734,27.734,0,0,0-4.05.1A6.305,6.305,0,0,0,6.991,3.08,2.049,2.049,0,0,0,6.4,4.068Z",
    transform: "translate(-0.016 -0.016)",
    fill: "#f3a940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38384",
    "data-name": "Path 38384",
    d: "M16.066,16.5c-.1.1-.1.1-.1.2v2.568c0,.494-.1.593-.593.4-.1-.1-.3-.1-.4-.2-.494-.2-.494-.2-.691.3-.3.79-.593,1.482-.889,2.272-.1.2,0,.3.2.3h4.445c.1,0,.3,0,.3-.2V19.167a3.148,3.148,0,0,0-1.778-1.778.74.74,0,0,1-.494-.79Z",
    transform: "translate(-0.102 -0.201)",
    fill: "#1092c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38385",
    "data-name": "Path 38385",
    d: "M6.2,19.266a2.735,2.735,0,0,0-.1.889v1.975a.262.262,0,0,0,.3.3h4.445c.2,0,.3,0,.2-.3-.3-.889-.691-1.778-.988-2.568-.1-.2-.1-.2-.3-.1-.3.1-.494.2-.79.3-.4.1-.494,0-.494-.3V16.8c0-.1.1-.3-.1-.2.1.494-.2.79-.691,1.086A2.185,2.185,0,0,0,6.2,19.266Z",
    transform: "translate(-0.013 -0.202)",
    fill: "#1092c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38386",
    "data-name": "Path 38386",
    d: "M6.4,4.059c.3-.3.4-.79.79-1.086A4.413,4.413,0,0,1,9.857,1.787a17.631,17.631,0,0,1,3.951-.1,4.659,4.659,0,0,1,3.161,1.185,5.428,5.428,0,0,1,.691.889c0,.1,0,.2.1.2A3.778,3.778,0,0,0,14.6.9a16.009,16.009,0,0,0-4.346,0,4.435,4.435,0,0,0-2.667.988A3.011,3.011,0,0,0,6.4,4.059Z",
    transform: "translate(-0.017 -0.008)",
    fill: "#f8cd64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38387",
    "data-name": "Path 38387",
    d: "M14.907,8.766a6.622,6.622,0,0,0,1.975,0c0-.2.1-.494,0-.691-.1-.1-.4,0-.593,0a6.3,6.3,0,0,1-3.556-.79c-.79-.4-1.58-.79-2.469-1.185a.449.449,0,0,0-.494,0A20.029,20.029,0,0,1,7.993,7.383.88.88,0,0,0,7.5,8.47c.691-.494,1.482-1.086,2.173-1.58a.585.585,0,0,1,.691-.1l2.371,1.185c.494.2.889.4,1.383.593A3.053,3.053,0,0,1,14.907,8.766Z",
    transform: "translate(-0.03 -0.072)",
    fill: "#f3ac7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38388",
    "data-name": "Path 38388",
    d: "M12.182,17.88a1.6,1.6,0,0,0,1.58-1.383c0-.2,0-.3-.2-.2a4.893,4.893,0,0,1-2.667,0c-.2-.1-.2,0-.2.2A1.435,1.435,0,0,0,12.182,17.88Z",
    transform: "translate(-0.07 -0.198)",
    fill: "#e9a077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38389",
    "data-name": "Path 38389",
    d: "M9.1,19.164c.79-.3,1.482-.593,2.173-.889A2.1,2.1,0,0,1,10.088,16.4c0-.1,0-.1-.1-.1H9.2c-.1,0-.1.1-.1.2Q9.1,17.683,9.1,19.164Z",
    transform: "translate(-0.05 -0.199)",
    fill: "#f6f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38390",
    "data-name": "Path 38390",
    d: "M13.2,18.275c.691.3,1.383.494,1.975.79.2.1.2,0,.2-.2V16.5c0-.2,0-.2-.2-.2h-.2c-.593,0-.593,0-.691.494A2.069,2.069,0,0,1,13.2,18.275Z",
    transform: "translate(-0.1 -0.199)",
    fill: "#f6f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38391",
    "data-name": "Path 38391",
    d: "M17.5,9.881v1.185c0,.2,0,.3.3.2a1.52,1.52,0,0,0,.988-1.482A1.486,1.486,0,0,0,17.8,8.4c-.2-.1-.3,0-.2.2A5.632,5.632,0,0,0,17.5,9.881Z",
    transform: "translate(-0.153 -0.101)",
    fill: "#e9a077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38392",
    "data-name": "Path 38392",
    d: "M6.885,8.4A1.37,1.37,0,0,0,5.7,9.783a1.759,1.759,0,0,0,.988,1.58c.1,0,.3.1.3-.1C6.885,10.277,6.885,9.289,6.885,8.4Z",
    transform: "translate(-0.008 -0.102)",
    fill: "#e9a077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38393",
    "data-name": "Path 38393",
    d: "M16.1,16.5c-.1.2,0,.494-.1.691,0,.1.1.1.1.2a3.869,3.869,0,0,1,2.074,1.877A3.217,3.217,0,0,0,16.1,16.5Z",
    transform: "translate(-0.135 -0.201)",
    fill: "#1bb8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38394",
    "data-name": "Path 38394",
    d: "M6.2,19.266a4.093,4.093,0,0,1,1.877-1.778c.494-.2.593-.494.4-.988A3.134,3.134,0,0,0,6.2,19.266Z",
    transform: "translate(-0.014 -0.201)",
    fill: "#1bb8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38395",
    "data-name": "Path 38395",
    d: "M11.191,21.074a1.253,1.253,0,0,0,.1-.593,1.467,1.467,0,0,0-.3-1.383c-.1-.2-.3,0-.4,0s-.2.1-.1.3A8.545,8.545,0,0,1,11.191,21.074Z",
    transform: "translate(-0.067 -0.232)",
    fill: "#f4f2ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38396",
    "data-name": "Path 38396",
    d: "M13.2,21.076c.2-.593.4-1.185.593-1.679.1-.1,0-.2-.1-.2s-.2-.2-.4,0a1.244,1.244,0,0,0-.3,1.284A.835.835,0,0,1,13.2,21.076Z",
    transform: "translate(-0.097 -0.233)",
    fill: "#f4f2ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38397",
    "data-name": "Path 38397",
    d: "M16.784,8.774c-.1-.1-.1-.1-.2-.1a4.758,4.758,0,0,1-1.679,0,3.415,3.415,0,0,1-1.185-.3A34.959,34.959,0,0,1,10.364,6.8c-.4-.2-.593-.2-.889.1-.494.4-1.086.79-1.679,1.185a1.363,1.363,0,0,0-.3.4,20.228,20.228,0,0,0,.1,3.457,4.6,4.6,0,0,0,4.642,3.951,4.756,4.756,0,0,0,4.642-3.951C16.883,10.848,16.784,9.761,16.784,8.774Z",
    transform: "translate(-0.03 -0.08)",
    fill: "#fecba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38398",
    "data-name": "Path 38398",
    d: "M12.169,12.1H10.194c-.4,0-.593.1-.494.593a2.1,2.1,0,0,0,1.778,1.679,2.535,2.535,0,0,0,2.766-.889,1.775,1.775,0,0,0,.4-.889c0-.4-.1-.494-.4-.494Z",
    transform: "translate(-0.057 -0.147)",
    fill: "#17171d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38399",
    "data-name": "Path 38399",
    d: "M8.278,21.879H9.562c.3,0,.4-.1.4-.4V20.6c0-.3-.1-.4-.4-.4H6.9a.362.362,0,0,0-.4.4v.889c0,.3.1.4.4.4Z",
    transform: "translate(-0.018 -0.246)",
    fill: "#17171d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38400",
    "data-name": "Path 38400",
    d: "M12.175,13h1.482a.363.363,0,0,0,.3-.1c.1-.2.1-.3-.2-.3H10.5c-.1,0-.3,0-.3.1a.262.262,0,0,0,.3.3Z",
    transform: "translate(-0.064 -0.153)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38401",
    "data-name": "Path 38401",
    d: "M10.8,13.3a2.026,2.026,0,0,0,2.864,0Z",
    transform: "translate(-0.071 -0.162)",
    fill: "#e20707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38402",
    "data-name": "Path 38402",
    d: "M8.286,21.293h.889c.2,0,.2-.1.2-.3s0-.3-.2-.3H7.4c-.3,0-.2.1-.2.3s0,.3.2.3Z",
    transform: "translate(-0.026 -0.253)",
    fill: "#f2a940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38405",
    "data-name": "Path 38405",
    d: "M14.39,10.574h0a.779.779,0,0,1-.79-.79V9.29a.779.779,0,0,1,.79-.79h0a.779.779,0,0,1,.79.79v.593A.7.7,0,0,1,14.39,10.574Z",
    transform: "translate(-0.105 -0.103)",
    fill: "#17171d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38406",
    "data-name": "Path 38406",
    d: "M9.99,10.574h0a.779.779,0,0,1-.79-.79V9.29a.779.779,0,0,1,.79-.79h0a.779.779,0,0,1,.79.79v.593A.763.763,0,0,1,9.99,10.574Z",
    transform: "translate(-0.051 -0.103)",
    fill: "#17171d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon10);
export default __webpack_public_path__ + "static/media/UserIcon10.1b0dbcb4f6eee79ac5db0cb026ba86b8.svg";
export { ForwardRef as ReactComponent };